'use strict';

/**
 * Quota view
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/quota.hbs');

var QuotaView = ColidoItemView.extend({
    template: template,

    className: function(){
        var classes = ['quota-container'];

        if (this.model.get('quotaUsage') / this.model.get('licenseQuota') > 0.8) {
            classes.push('quoata-near-limit');
        }

        if (this.model.get('quotaUsage') > this.model.get('licenseQuota')) {
            classes.push('quoata-exeeded');
        }

        return classes.join(' ');
    },

    modelEvents: {
        'change:licenseQuota change:quotaUsage': 'render',
    },

    onRender: function() {
        this.$el.attr('class', _.result(this, 'className'));
    },
});

module.exports = QuotaView;